// True when the collapsed range sits at the absolute start/end of `boundary`
// (walking up through wrapping elements, not just the immediate parent).
function isAtRangeEdge(rng: Range, boundary: Node, start: boolean): boolean {
	let node: Node = rng.startContainer;
	let offset = rng.startOffset;
	while (node !== boundary) {
		if (!node.parentNode || !boundary.contains(node)) return false;
		const length = node.nodeType === Node.TEXT_NODE ? (node as Text).length : node.childNodes.length;
		if (offset !== (start ? 0 : length)) return false;
		const parent = node.parentNode;
		const idx = Array.from(parent.childNodes).indexOf(node as ChildNode);
		offset = start ? idx : idx + 1;
		node = parent;
	}
	return offset === (start ? 0 : boundary.childNodes.length);
}

export function isAtRangeStart(rng: Range, boundary: Node) {
	return isAtRangeEdge(rng, boundary, true);
}

export function isAtRangeEnd(rng: Range, boundary: Node) {
	return isAtRangeEdge(rng, boundary, false);
}
